import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { DeliveryDestinationNote, DeliveryDestinations } from '../../../../interfaces/deliveryDestionations.model';
import { CustomersEditAddressDetailsDialogComponent } from '../customers-edit-address-details-dialog-component/customers-edit-address-details-dialog-component';

@Component({
  selector: 'cus-customers-address-details-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslocoDirective,
  ],
  templateUrl: './customers-address-details-dialog-component.html',
  styleUrl: './customers-address-details-dialog-component.scss',
})
export class CustomersAddressDetailsDialogComponent {
  readonly mainFields = [
    { label: 'Riferimento', key: 'riferimento' },
    { label: 'Citta', key: 'citta' },
    { label: 'CAP', key: 'cap' },
    { label: 'Indirizzo', key: 'indirizzo' },
  ] as const;

  readonly noteFields: { label: string; key: keyof DeliveryDestinationNote }[] = [
    { label: 'Nota libera', key: 'notaLibera' },
    { label: 'Orari', key: 'orari' },
    { label: 'Contatto', key: 'contatto' },
    { label: 'Sponda', key: 'sponda' },
  ] as const;

  private editAddressDetailsDialogRef?: MatDialogRef<CustomersEditAddressDetailsDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CustomersAddressDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: DeliveryDestinations,
  ) {}

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.dialogRef.close({ action: 'reset' });
  }

  onApply() {
    this.dialogRef.close({ action: 'apply' });
  }

  openEditDialog() {
    if (this.editAddressDetailsDialogRef) {
      return;
    }

    this.editAddressDetailsDialogRef = this.dialog.open(CustomersEditAddressDetailsDialogComponent, {
      data: this.data,
    });
    this.editAddressDetailsDialogRef.afterClosed().subscribe(value => {
      this.editAddressDetailsDialogRef = undefined;

      if (value) {
        this.dialogRef.close({ action: 'edit', destination: this.data, value });
      }
    });
  }
}
